var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.21 42.5645H3.78C1.69 42.5645 0 40.8645 0 38.7845V3.78446C0 1.69446 1.7 0.00445557 3.78 0.00445557H24.6C25.12 0.00445557 25.55 0.424456 25.55 0.954456C25.55 1.48446 25.13 1.90446 24.6 1.90446H3.78C2.74 1.90446 1.89001 2.75445 1.89001 3.79445V38.7945C1.89001 39.8345 2.74 40.6845 3.78 40.6845H31.21C32.25 40.6845 33.1 39.8345 33.1 38.7945V10.4145C33.1 9.89446 33.52 9.46446 34.05 9.46446C34.58 9.46446 35 9.88446 35 10.4145V38.7945C35 40.8845 33.3 42.5745 31.22 42.5745L31.21 42.5645Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0501 11.3544H24.5901C24.0701 11.3544 23.6401 10.9344 23.6401 10.4044V0.944444C23.6401 0.564444 23.8701 0.214445 24.2201 0.0744447C24.5701 -0.0755553 24.9801 0.00444376 25.2501 0.284444L34.7101 9.74444C34.9801 10.0144 35.0601 10.4244 34.9201 10.7744C34.7701 11.1244 34.4301 11.3544 34.0501 11.3544ZM25.5401 9.46444H31.7701L25.5401 3.23444V9.46444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 22.7144C23.24 22.7144 22.87 22.5744 22.6 22.2944L16.94 16.6344L11.29 22.2844C10.74 22.8344 9.84003 22.8344 9.28003 22.2844C8.72003 21.7344 8.73003 20.8344 9.28003 20.2744L15.93 13.6244C16.48 13.0744 17.38 13.0744 17.94 13.6244L24.6 20.2844C25.15 20.8344 25.15 21.7344 24.6 22.2944C24.32 22.5744 23.96 22.7144 23.6 22.7144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9302 33.0244C16.1502 33.0244 15.5103 32.3844 15.5103 31.6044V14.6244C15.5103 13.8444 16.1502 13.2044 16.9302 13.2044C17.7102 13.2044 18.3503 13.8444 18.3503 14.6244V31.6044C18.3503 32.3844 17.7102 33.0244 16.9302 33.0244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.78d684b12d586a973c89f77831713fff.svg";
export { ForwardRef as ReactComponent };